import fontawesome from "@fortawesome/fontawesome"

import {
  faFacebook,
  faGoogleDrive,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons"
import { faImage, faPlayCircle } from "@fortawesome/free-regular-svg-icons"
import {
  faBell,
  faLink,
  faExternalLinkAlt,
  faPenAlt,
  faPencilAlt,
  faTrash,
  faMicrophone,
  faVideo,
  faUserFriends,
  faCamera,
  faStar,
  faEnvelope,
  faClipboard,
  faClipboardList,
  faMapMarkerAlt,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faCopy,
  faMagic,
  faMapMarkedAlt,
  faEllipsisH,
  faFilter,
  faFileAlt,
  faFilePdf,
  faCalendarCheck,
  faBuilding,
  faUser,
  faUsers,
  faFile,
  faLandmark,
  faInfoCircle,
  faTimesCircle,
  faDownload,
  faCalendarPlus,
  faArrowLeft,
  faDice,
  faPhone,
  faGlobe,
  faChevronDown,
  faBan,
  faCheckCircle,
  faEye,
  faCaretRight,
} from "@fortawesome/free-solid-svg-icons"

import { cbOverflow } from "./cbOverflow"
import { cbPlus } from "./cbPlus"
import { cbSearch } from "./cbSearch"

// Fix FontAwesome icon flashing
// https://medium.com/@fabianterh/fixing-flashing-huge-font-awesome-icons-on-a-gatsby-static-site-787e1cfb3a18
fontawesome.config.autoAddCss = false

export function setupFontawesomeIcons() {
  fontawesome.library.add(
    faFacebook,
    faGoogleDrive,
    faTwitter,
    faImage,
    faPlayCircle,
    faBell,
    faLink,
    faExternalLinkAlt,
    faPenAlt,
    faPencilAlt,
    faTrash,
    faMicrophone,
    faMapMarkedAlt,
    faVideo,
    faUserFriends,
    faCamera,
    faStar,
    faEnvelope,
    faClipboard,
    faClipboardList,
    faMapMarkerAlt,
    faEllipsisH,
    faChevronUp,
    faChevronLeft,
    faChevronRight,
    faCopy,
    faMagic,
    faFilter,
    faFileAlt,
    faFilePdf,
    faCalendarCheck,
    faBuilding,
    faLandmark,
    faUser,
    faUsers,
    faFile,
    faInfoCircle,
    faTimesCircle,
    faDownload,
    faCalendarPlus,
    faArrowLeft,
    faDice,
    faPhone,
    faGlobe,
    faChevronDown,
    faBan,
    faCheckCircle,
    faEye,
    faCaretRight,
    cbOverflow,
    cbPlus,
    cbSearch
  )

  fontawesome.dom.i2svg()
}
